import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { IItems, ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { tenantsTableColumns } from '../constants';
import { IUser } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface TenantsTableProps {
  tenantsTableTableData: any;
  sort: ISort;
  loading: boolean;
  flashUpdatingRow: string;
  setSort: (value: ISort) => void;
  actionsByStatus: (row: IUser) => IItems[];
}

const TenantsTable = ({ sort, loading, tenantsTableTableData, flashUpdatingRow, setSort, actionsByStatus }: TenantsTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <MobileTable tenantsTableTableData={tenantsTableTableData} flashUpdatingRow={flashUpdatingRow} actionsByStatus={actionsByStatus} />
          )}
        </>
      ) : (
        <>
          <TableHeader refetch={() => {}} columns={tenantsTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <TableBody tenantsTableTableData={tenantsTableTableData} flashUpdatingRow={flashUpdatingRow} actionsByStatus={actionsByStatus} />
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default TenantsTable;
